module.exports = __webpack_public_path__ + "18e41ff1e81ad45948879bed4629f8c7.pdf";